export default __webpack_public_path__ + "static/media/logo_login.8c056a63.png";